export default __webpack_public_path__ + "static/media/RecordScreenshot.aacc3650.png";